import React from "react";
import "./SecondSection.css";

import bgImage from "../../assets/parallax-bg-03.jpg";

const SecondSection = () => {
  return (
    <section
      className="second-section"
      style={{
        backgroundImage: `
        linear-gradient(rgba(248,249,250,0.92), rgba(248,249,250,0.92)),
        url(${bgImage})
        `
      }}
    >

      <div className="second-container">

        <h2>Our Services</h2>

        <p className="section-subtitle">
          End-to-End Solutions for Energy & Infrastructure
        </p>

        <div className="services-grid">

          {/* CARD 1 */}

          <div className="service-card">

            <div className="service-icon">⚡</div>

            <h3>Renewable Energy Solutions</h3>

            <p>
              We develop and execute solar power projects designed for
              long-term performance.
            </p>

            <ul>
              <li>✓ Site assessment & feasibility</li>
              <li>✓ Design & engineering</li>
              <li>✓ Procurement & installation</li>
              <li>✓ Testing & commissioning</li>
            </ul>

          </div>

          {/* CARD 2 */}

          <div className="service-card">

            <div className="service-icon">🗼</div>

            <h3>Transmission & Distribution</h3>

            <p>
              Execution of transmission lines and substations with full
              compliance.
            </p>

            <ul>
              <li>✓ 33kV to 220kV transmission lines</li>
              <li>✓ Substations & switchyards</li>
              <li>✓ Power evacuation systems</li>
            </ul>

          </div>

          {/* CARD 3 */}

          <div className="service-card">

            <div className="service-icon">🏗️</div>

            <h3>EPC Services</h3>

            <p>
              End-to-end project execution from concept to commissioning.
            </p>

            <ul>
              <li>✓ Engineering</li>
              <li>✓ Procurement</li>
              <li>✓ Construction</li>
              <li>✓ Project management</li>
            </ul>

          </div>

        </div>

      </div>

    </section>
  );
};

export default SecondSection;